import React from 'react';

import {TabContainer} from './TabContainer';

interface ExpandedTabContainerProps {
  activeTab: string;
  className?: string;
  children: React.ReactNode;
  onRequestTabChange: (tabKey: string) => void;
}

export function ExpandedTabContainer(props: ExpandedTabContainerProps): JSX.Element {
  return (
    <div className="expandedTabContainer u-flex-full-height">
      <TabContainer isFullHeight={true} {...props} />
    </div>
  );
}

// Re-export for convenience
export {Tab} from './TabContainer';
